import { render, staticRenderFns } from "./TaskAssignedToUser.vue?vue&type=template&id=2a19b165&scoped=true"
import script from "./TaskAssignedToUser.vue?vue&type=script&lang=js"
export * from "./TaskAssignedToUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a19b165",
  null
  
)

export default component.exports